import * as THREE from "three";

/**
 * Visual-only scene objects must not participate in pointer hit testing.
 * In particular, Three.js line segments have a one-world-unit raycast
 * tolerance by default, which is much wider than their rendered stroke.
 */
export const disablePointerRaycast: THREE.Object3D["raycast"] = () =>
  undefined;
